<template>
  <v-app id="main-app-wrapper">
    <MainNavigation />
    <v-main>
      <router-view class="page-wrapper" :key="$route.path" />
    </v-main>
    <SnackBar />
    <Loader />
    <Footer :appVersion="appVersion" />
    <KeycloakComponent />
  </v-app>
</template>

<script>
import MainNavigation from '@/components/generic/main-navigation.vue';
import SnackBar from '@/components/generic/snackbar.vue';
import Loader from '@/components/generic/main-loader.vue';
import Footer from '@/components/generic/footer.vue';
import { handleInternetConnectivity } from '@/utils/functions.js';
import KeycloakComponent from '@/components/generic/keycloak-component.vue';
//styles
import '@/assets/scss/generic.scss';

export default {
  name: 'App',
  components: {
    MainNavigation,
    SnackBar,
    Loader,
    Footer,
    KeycloakComponent
  },
  data: () => ({
    appVersion: process.env.VUE_APP_TAG_VERSION
  }),
  computed: {},
  async created() {},
  mounted() {
    handleInternetConnectivity(); //functions.js
    this.setLanguage();
  },
  methods: {
    setLanguage() {
      const languageLocalStorage = localStorage.getItem('language');
      if (languageLocalStorage != null) {
        this.$store.commit('SET_SELECTED_LANGUAGE', languageLocalStorage);
      } else {
        this.$store.commit('SET_SELECTED_LANGUAGE', this.$store.state.config.defaultLanguage);
      }
    }
  }
};
</script>

<style lang="scss">
.v-input--is-disabled {
  input,
  textarea {
    color: rgba(0, 0, 0, 0.8) !important;
  }
}

.bg-light-primary {
  background: #e8f2ff !important;
}

.border-bottom-light {
  border-bottom: 1px solid #e0e0e0;
}

.bg-whitesmoke {
  background: #d9eaf2 !important;
}
.bg-white {
  background: #fff !important;
}
</style>
